<form [formGroup]="searchForm">

	@if (isCustomerCare) {

	<div class="form-group">
		<span data-testid="SUBSYS2_LISTSEARCH_CLEAR_BTN" class="a-link clear-filter" (click)="clearFilters()"
			(keypress)="clearFilters()">
			{{ labels().FILTERS_COMPONENT_CLEAR_FILTERS }}
		</span>

		<label data-testid="SUBSYS2_LISTSEARCH_USERNAME_LBL" for="userName">
			{{ labels().FILTERS_COMPONENT_USER_NAME }}
		</label>
		<input data-testid="SUBSYS2_LISTSEARCH_USERNAME_INPUT" type="text" autocomplete="off" class="form-control"
			id="userName" [placeholder]="labels().FILTERS_COMPONENT_USER_NAME" formControlName="userName"
			[class.is-invalid]="searchForm.controls.userName.invalid" [appFormValidationMsg]="errorMsgs.userName" />
	</div>

	<div class="form-group">
		<div class="custom-control custom-checkbox custom-control-inline">
			<input data-testid="SUBSYS2_LISTSEARCH_DELETED_INPUT" type="checkbox" class="custom-control-input"
				id="showDeleted" name="showDeleted" formControlName="showDeleted" />
			<label data-testid="SUBSYS2_LISTSEARCH_DELETED_LBL" class="custom-control-label" for="showDeleted">
				{{ labels().FILTERS_COMPONENT_SHOW_DELETED }}
			</label>
		</div>
	</div>

	}

	<div class="form-group">
		@if (!isCustomerCare) {
		<span data-testid="SUBSYS2_LISTSEARCH_CLEAR_BTN" class="clear-filter" (click)="clearFilters()"
			(keypress)="clearFilters()">
			{{ labels().FILTERS_COMPONENT_CLEAR_FILTERS }}
		</span>
		}

		<label data-testid="SUBSYS2_LISTSEARCH_PATID_LBL" for="patientId">
			{{ labels().FILTERS_COMPONENT_PATIENT_ID }}
		</label>
		<input data-testid="SUBSYS2_LISTSEARCH_PATID_INPUT" type="text" autocomplete="off" class="form-control"
			id="patientId" [placeholder]="labels().FILTERS_COMPONENT_PATIENT_ID" formControlName="patientId"
			[class.is-invalid]="searchForm.controls.patientId.invalid" [appFormValidationMsg]="errorMsgs.patientId" />
	</div>

	<div class="form-group">
		<label data-testid="SUBSYS2_LISTSEARCH_PLANID_LBL" for="planId">
			{{ labels().FILTERS_COMPONENT_PLAN_ID }}
		</label>
		<input data-testid="SUBSYS2_LISTSEARCH_PLANID_INPUT" type="text" autocomplete="off" class="form-control" id="planId"
			[placeholder]="labels().FILTERS_COMPONENT_PLAN_ID" formControlName="planId"
			[class.is-invalid]="searchForm.controls.planId.invalid" [appFormValidationMsg]="errorMsgs.planId" />
	</div>

	<div class="form-group" #planDateTarget>
		<label for="" data-testid="SUBSYS2_LISTSEARCH_UPDATEDATE_LBL">
			{{ labels().FILTERS_COMPONENT_PLAN_MODIFICATION_DATE }}
			<span data-testid="SUBSYS2_LISTSEARCH_FORMATDATE_TXT" class="date-format ms-3">{{ dateFormat }}</span>
		</label>
		<div class="input-group wrapper-calendar">
			<i data-testid="SUBSYS2_LISTSEARCH_UPDATEDATE_TOGGLE_BTN" class="material-icons input-group-append icon-calendar"
				(click)="planDatePicker.toggle()" (keypress)="planDatePicker.toggle()">today</i>
			<input data-testid="SUBSYS2_LISTSEARCH_UPDATEDATE_INPUT" class="form-control" type="text"
				[placeholder]="labels().FILTERS_COMPONENT_PLAN_MODIFICATION_DATE" name="planDateRange" [value]="planDateFormat"
				readonly style="color: #fff">
			<i data-testid="SUBSYS2_LISTSEARCH_UPDATEDATE_CLEAR_BTN"
				class="material-icons input-group-append align-self-center md-18" (click)="planDateClear()"
				(keypress)="planDateClear()">clear</i>
		</div>
	</div>
	<app-daterangepicker data-testid="SUBSYS2_LISTSEARCH_UPDATEDATE_DATEPICKER" #planDatePicker [range]="planDateRange"
		(rangeChanged)="updatePlanDateRange($event)" [positionTarget]="planDateTarget" placement="bottom-start" />


	<button data-testid="SUBSYS2_LISTSEARCH_SEARCH_BTN" type="button" class="btn btn-primary"
		[disabled]="searchForm.invalid" (click)="search()">
		{{ labels().FILTERS_COMPONENT_SEARCH }}
	</button>

</form>

<div class="form-group">
	@if (!isAllFiltersCollapsed) {
	<span data-testid="SUBSYS2_LISTSEARCH_COLLAPSE_BTN" class="d-inline-block all-filters" (click)="collapseAllFilters()"
		(keypress)="collapseAllFilters()">
		{{ labels().FILTERS_COMPONENT_COLLAPSE_FILTERS }}
	</span>
	} @else {
	<span data-testid="SUBSYS2_LISTSEARCH_SHOW_BTN" class="d-inline-block all-filters" (click)="showAllFilters()"
		(keypress)="showAllFilters()">
		{{ labels().FILTERS_COMPONENT_SHOW_FILTERS }}
	</span>
	}
</div>

<form [formGroup]="filtersForm">

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_PLANVERSION_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[0]"
			(click)="changeFilterVisibility(0)" (keypress)="changeFilterVisibility(0)">
			{{ labels().FILTERS_COMPONENT_PLAN_VERSION }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[0]">
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_UPTODATE_INPUT" type="checkbox" class="custom-control-input"
					id="uptodateFilter" name="planVersion" (change)="changeUptodateFilter()" />
				<label data-testid="SUBSYS2_LISTSEARCH_UPTODATE_LBL" class="custom-control-label" for="uptodateFilter">
					{{ labels().FILTERS_COMPONENT_PLAN_UPTODATE }}
				</label>
			</div>
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_OUTDATED_INPUT" type="checkbox" class="custom-control-input"
					id="outdatedFilter" name="planVersion" (change)="changeOutdatedFilter()" />
				<label data-testid="SUBSYS2_LISTSEARCH_OUTDATED_LBL" class="custom-control-label" for="outdatedFilter">
					{{ labels().FILTERS_COMPONENT_PLAN_OUTDATED }}
				</label>
			</div>
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_DEVICE_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[1]"
			(click)="changeFilterVisibility(1)" (keypress)="changeFilterVisibility(1)">
			{{ labels().FILTERS_COMPONENT_DEVICE }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[1]" formArrayName="device">
			@for (device of deviceGroup.controls; track $index; let i = $index) {
			<div class="custom-control custom-checkbox custom-control-inline">
				<input data-testid="SUBSYS2_LISTSEARCH_DEVICE_INPUT" type="checkbox" class="custom-control-input"
					[id]="'device_' + deviceList[i]" name="device" [formControlName]="i"
					(change)="submitDevice(deviceGroup.value)" />
				<label data-testid="SUBSYS2_LISTSEARCH_DEVICE_LBL" class="custom-control-label"
					[for]="'device_' + deviceList[i]">
					{{ deviceList[i] | deviceLabel | uppercase }}</label>
			</div>
			}
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_GENDER_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[2]"
			(click)="changeFilterVisibility(2)" (keypress)="changeFilterVisibility(2)">
			{{ labels().FILTERS_COMPONENT_GENDER }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[2]" formArrayName="gender">
			@for (gender of genderGroup.controls; track $index; let i = $index) {
			<div class="custom-control custom-checkbox custom-control-inline">
				<input data-testid="SUBSYS2_LISTSEARCH_GENDER_INPUT" type="checkbox" class="custom-control-input"
					[id]="'gender_' + genderList[i]" name="gender" [formControlName]="i"
					(change)="submitGender(genderGroup.value)" />
				<label data-testid="SUBSYS2_LISTSEARCH_GENDER_LBL" class="custom-control-label"
					[for]="'gender_' + genderList[i]">{{ genderList[i] }}</label>
			</div>
			}
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_SIDE_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[3]"
			(click)="changeFilterVisibility(3)" (keypress)="changeFilterVisibility(3)">
			{{ labels().FILTERS_COMPONENT_SIDE }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[3]" formArrayName="side">
			@for (side of sideGroup.controls; track $index; let i = $index) {
			<div class="custom-control custom-checkbox custom-control-inline">
				<input data-testid="SUBSYS2_LISTSEARCH_SIDE_INPUT" type="checkbox" class="custom-control-input"
					[id]="'side_' + sideList[i]" name="side" [formControlName]="i" (change)="submitSide(sideGroup.value)" />
				<label data-testid="SUBSYS2_LISTSEARCH_SIDE_LBL" class="custom-control-label" [for]="'side_' + sideList[i]">
					{{ sideList[i] | anatomicalSideLabel }}</label>
			</div>
			}
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_BONE_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[4]"
			(click)="changeFilterVisibility(4)" (keypress)="changeFilterVisibility(4)">
			{{ labels().FILTERS_COMPONENT_BONE_TYPE }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[4]" formArrayName="bone">
			@for (bone of boneGroup.controls; track $index; let i = $index) {
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_BONE_INPUT" type="checkbox" class="custom-control-input"
					[id]="'bone_' + boneList[i]" name="bone" [formControlName]="i" (change)="submitBone(boneGroup.value)" />
				<label data-testid="SUBSYS2_LISTSEARCH_BONE_LBL" class="custom-control-label" [for]="'bone_' + boneList[i]">
					{{ boneList[i] | boneTypeLabel }}</label>
			</div>
			}
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_TYPE_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[5]"
			(click)="changeFilterVisibility(5)" (keypress)="changeFilterVisibility(5)">
			{{ labels().FILTERS_COMPONENT_PLAN_TYPE }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[5]" formArrayName="planType">
			@for (planType of planTypeGroup.controls; track $index; let i = $index) {
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_TYPE_INPUT" type="checkbox" class="custom-control-input"
					[id]="'planType_' + planTypeList[i]" name="planType" [formControlName]="i"
					(change)="submitPlanType(planTypeGroup.value)" />
				<label data-testid="SUBSYS2_LISTSEARCH_TYPE_LBL" class="custom-control-label"
					[for]="'planType_' + planTypeList[i]">
					{{ planTypeList[i] | planTypeLabel }}
				</label>
			</div>
			}
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_SCENARIO_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[6]"
			(click)="changeFilterVisibility(6)" (keypress)="changeFilterVisibility(6)">
			{{ labels().FILTERS_COMPONENT_PLAN_SCENARIO }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[6]">
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_PREOP_INPUT" type="checkbox" class="custom-control-input"
					id="preOpFilter" name="planScenario" (change)="changePreOpFilter()" />
				<label data-testid="SUBSYS2_LISTSEARCH_PREOP_LBL" class="custom-control-label" for="preOpFilter">
					{{ labels().FILTERS_COMPONENT_PRE_OP }}
				</label>
			</div>
			<div class="custom-control custom-checkbox custom-control-inline w-50 me-0">
				<input data-testid="SUBSYS2_LISTSEARCH_POSTOP_INPUT" type="checkbox" class="custom-control-input"
					id="postOpFilter" name="planScenario" (change)="changePostOpFilter()" />
				<label data-testid="SUBSYS2_LISTSEARCH_POSTOP_LBL" class="custom-control-label" for="postOpFilter">
					{{ labels().FILTERS_COMPONENT_POST_OP }}
				</label>
			</div>
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_AGE_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[7]"
			(click)="changeFilterVisibility(7)" (keypress)="changeFilterVisibility(7)">
			{{ labels().FILTERS_COMPONENT_AGE }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[7]">
			<input data-testid="SUBSYS2_LISTSEARCH_AGE_INPUT" id="ageSlider" type="text" />
			<span data-testid="SUBSYS2_LISTSEARCH_AGE_TXT" class="help-text">{{ rangeAge }}</span>
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_WEIGHT_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[8]"
			(click)="changeFilterVisibility(8)" (keypress)="changeFilterVisibility(8)">
			{{ labels().FILTERS_COMPONENT_WEIGHT }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[8]">
			<input data-testid="SUBSYS2_LISTSEARCH_WEIGHT_INPUT" id="weightSlider" type="text" />
			<span data-testid="SUBSYS2_LISTSEARCH_WEIGHT_KG_TXT" class="help-text">{{ rangeWeightKg }}</span><br />
			<span data-testid="SUBSYS2_LISTSEARCH_WEIGHT_LB_TXT" class="help-text">{{ rangeWeightLb }}</span>
		</div>
	</div>

	<div class="wrapper-accordion-form">
		<h5 data-testid="SUBSYS2_LISTSEARCH_HEIGHT_TOGGLE" class="title-accordion" [class.active]="isFilterVisible[9]"
			(click)="changeFilterVisibility(9)" (keypress)="changeFilterVisibility(9)">
			{{ labels().FILTERS_COMPONENT_HEIGHT }}
			<div class="fake-material-icon icon-expand expand"></div>
		</h5>
		<div class="form-group" [hidden]="!isFilterVisible[9]">
			<input data-testid="SUBSYS2_LISTSEARCH_HEIGHT_INPUT" id="heightSlider" type="text" />
			<span data-testid="SUBSYS2_LISTSEARCH_HEIGHT_CM_TXT" class="help-text">{{ rangeHeightCm }}</span><br />
			<span data-testid="SUBSYS2_LISTSEARCH_HEIGHT_FT_TXT" class="help-text">{{ rangeHeightFt }}</span>
		</div>
	</div>

</form>